import react, { useState, Fragment, useEffect } from "react";
import "./App.css";
import Landing from "./components/Landing";
import Resourcedetails from "./components/Resourcedetails";
import { Link, useLocation } from "react-router-dom";
import Favorite from "./components/Favorite";
import { useDispatch, useSelector } from "react-redux";
import { ramactions } from "./store/index";
import { useTranslation} from "react-i18next";
import RAMFooter from "./components/RAM-Footer";


function App() {
  const { t } = useTranslation("translation", { keyPrefix: "app" });  
  const [isDetailsPage, setIsDetailsPage] = useState(false);
  const [resultShowing, setresultShowing] = useState(false);
  const displaystatus = useSelector((index) => index.displaystatus);
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const isError = useSelector((index) => index.isError);
  const errormsg = useSelector((index) => index.errormsg);
  useEffect(() => {    
    document.getElementById("main").classList.add("ram");
    document.querySelector("h1").remove();
    /*let favoritearray = [];
    const favoritearraylocalStorage = localStorage.getItem("favorites");
    if (
      favoritearraylocalStorage !== null &&
      favoritearraylocalStorage !== undefined
    ) {
      const localfavoritearray = favoritearraylocalStorage.split(",");
      localfavoritearray.map((index) => {
        favoritearray.push(index);
      });
      console.log(favoritearray);
      dispatch(ramactions.addfavorite(favoritearray));
    }*/
    if (location.hash === "#favorites") {
      dispatch(ramactions.changestatus(2));
    }

    const resourceDetailsURL = queryParams.get("id");
    if (resourceDetailsURL) {
      setIsDetailsPage(true);
      dispatch(ramactions.changestatus(1));
    } else {
      setIsDetailsPage(false);
    }

    window.onload = function () {
      if (
        document
          .querySelector("#main.ram #content")
          .classList.contains("container")
      ) {
        document
          .querySelector("#main.ram #content")
          .classList.remove("container");
        document
          .querySelector("#main.ram #content")
          .classList.add("container-fluid");
      }
    };

    
    
  }, []);
  useEffect(()=>{
    // Fix for header hiding issue on devices
    document.body.classList.add('ram-react');
    return () =>{
      document.body.classList.remove('ram-react');
    }
  },[])



  const showFavorite = () => {
    dispatch(ramactions.changestatus(2));
  };

  const showSearchhome = () => {
    dispatch(ramactions.changestatus(0));
  };

  const onShowResults = (status) => {
    setresultShowing(status);
  };
  return (
    <Fragment>
      {isError === 0 && (
        <Fragment>
          {displaystatus === 0 && (
            <div className={!resultShowing && "ram-landing-page"}>
              <Landing resultShowStatusHandler={onShowResults} />
            </div>
          )}
          <div>
            {displaystatus === 1 && <Resourcedetails />}
            {displaystatus === 2 && <Favorite />}
          </div>
        </Fragment>
      )}
      {isError === 1 && (
        <Fragment>
          <p>{t("error_description")}</p>
          <p>{errormsg}</p>
        </Fragment>
      )}
      <RAMFooter />
      
    </Fragment>
  );
}

export default App;
